module.exports = __webpack_public_path__ + "resources/img/img_ahnlab_cpp.8886092e46fe9a4941be661bfdeed61f.png";